import { h } from 'preact';
export const ChevronsUp = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polyline", { points: "17 11 12 6 7 11" }),
        h("polyline", { points: "17 18 12 13 7 18" })));
};
//# sourceMappingURL=chevrons-up.js.map